import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { LayoutGrid, List } from 'lucide-react';

export type OrdersViewMode = 'table' | 'cards';

export interface OrdersViewToggleProps {
  value: OrdersViewMode;
  onChange: (mode: OrdersViewMode) => void;
  disabled?: boolean;
  className?: string;
  labels?: {
    table: string;
    cards: string;
  };
}

const DEFAULT_LABELS: OrdersViewToggleProps['labels'] = {
  table: 'Table view',
  cards: 'Card view',
};

export const OrdersViewToggle = ({
  value,
  onChange,
  disabled = false,
  className,
  labels = DEFAULT_LABELS,
}: OrdersViewToggleProps) => {
  const isTable = value === 'table';
  const isCards = value === 'cards';

  return (
    <div className={cn('flex w-full flex-col gap-2 sm:w-auto sm:flex-row sm:items-center', className)}>
      <Button
        variant="outline"
        size="sm"
        className={cn(
          'flex-1 rounded-2xl border border-border/60 bg-card/80 text-sm font-medium transition sm:flex-none sm:min-w-[140px]',
          isTable
            ? 'border-primary/40 bg-primary/10 text-foreground shadow-sm'
            : 'hover:border-primary/30 hover:bg-primary/5'
        )}
        onClick={() => onChange('table')}
        aria-pressed={isTable}
        disabled={disabled && !isTable}
      >
        <List className="mr-2 h-4 w-4" />
        {labels.table}
      </Button>
      <Button
        variant="outline"
        size="sm"
        className={cn(
          'flex-1 rounded-2xl border border-border/60 bg-card/80 text-sm font-medium transition sm:flex-none sm:min-w-[140px]',
          isCards
            ? 'border-primary/40 bg-primary/10 text-foreground shadow-sm'
            : 'hover:border-primary/30 hover:bg-primary/5'
        )}
        onClick={() => onChange('cards')}
        aria-pressed={isCards}
        disabled={disabled && !isCards}
      >
        <LayoutGrid className="mr-2 h-4 w-4" />
        {labels.cards}
      </Button>
    </div>
  );
};
